<script setup lang="ts">
import {
  DialogRoot,
  DialogTrigger,
  DialogPortal,
  DialogOverlay,
  DialogContent,
  DialogClose
} from 'radix-vue'
import { computed } from 'vue'
import { cn } from '@/lib/utilities'

type SheetSide = 'top' | 'bottom' | 'left' | 'right'

const props = withDefaults(
  defineProps<{
    open?: boolean
    side?: SheetSide
    wide?: boolean
  }>(),
  {
    side: 'right'
  }
)

const emit = defineEmits<{
  'update:open': [value: boolean]
}>()

const sideClasses: Record<SheetSide, string> = {
  top: 'sheet-content--top',
  bottom: 'sheet-content--bottom',
  left: 'sheet-content--left',
  right: 'sheet-content--right'
}

const contentClasses = computed(() =>
  cn('panel-ui', 'sheet-content', sideClasses[props.side], { 'sheet-content--wide': props.wide })
)

const portalTarget = computed(() => (props.side === 'left' ? '#left-panels' : '#right-panels'))
</script>

<template>
  <DialogRoot :open="open" :modal="false" @update:open="emit('update:open', $event)">
    <slot name="trigger">
      <DialogTrigger as-child>
        <slot name="trigger-content" />
      </DialogTrigger>
    </slot>

    <DialogPortal :to="portalTarget">
      <DialogContent :class="contentClasses" @interact-outside.prevent @escape-key-down.prevent>
        <slot />
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>
